// extracted by mini-css-extract-plugin
export default {"grid":"grid--HE_b4","flex":"flex--ADo7y","createdBy":"createdBy--UGPYh","elide":"elide--Xl91b","number":"number--mWV5x"};